import { Component, Input } from '@angular/core';
import { IToolbarItem } from '@shared/interfaces/toolbar-item.interface';
import { Location } from '@angular/common';

@Component({
  selector: 'app-submenu',
  templateUrl: './submenu.component.html',
  styleUrls: ['./submenu.component.scss']
})
export class SubmenuComponent {

  @Input() items: Array<IToolbarItem> = [];
  @Input() backBgGray: boolean = false;
  @Input() isHide?: boolean;

  constructor(public location: Location) {};

  goBack(){
    this.location.back();
 }


}
